import BottomSheetButton from "shared/components/forms/buttons/BottomSheetButton";
import SkipButtonGroup from "./SkipButtonGroup";
import SubmitButton from "./SubmitNextButton";

const FormControls = ({
  isStepSkippable,
  onNextHandler,
  isLastStep,
}: {
  isStepSkippable: boolean;
  onNextHandler: () => void;
  isLastStep: boolean;
}) => (
  <div className="controls-container">
    {isStepSkippable ? (
      <SkipButtonGroup onSkipHandler={onNextHandler} isLastStep={isLastStep} />
    ) : (
      <SubmitButton isLastStep={isLastStep} />
    )}
    <BottomSheetButton
      id="whydoweask-button"
      label="Why do we ask?"
      className="popup-or-exit-button"
    >
      <div>TODO</div>
    </BottomSheetButton>
  </div>
);

export default FormControls;
